import React from 'react';
import { css } from '@emotion/react';
import useTranslation from 'next-translate/useTranslation';

const containerStyle = css`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;
  width: 100%;
  height: 20px;
`;

const iconContainerStyle = css`
  width: 12px;
  height: 12px;
  position: relative;
  border-radius: 100px;
  overflow: hidden;
`;

const iconBackgroundStyle = css`
  width: 10.5px;
  height: 10.5px;
  position: absolute;
  left: 0.75px;
  top: 0.75px;
  background: #ff3a58;
  border-radius: 9999px;
`;

const iconExclamationStyle = css`
  width: 1.5px;
  height: 3.75px;
  position: absolute;
  left: 5.25px;
  top: 3px;
  background: white;
`;

const iconDotStyle = css`
  width: 1.5px;
  height: 1.5px;
  position: absolute;
  left: 5.25px;
  top: 7.5px;
  background: white;
  border-radius: 9999px;
`;

const textStyle = css`
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
`;

const StoryGameCharacterListError: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div css={containerStyle}>
      <div css={iconContainerStyle}>
        <div css={iconBackgroundStyle} />
        <div css={iconExclamationStyle} />
        <div css={iconDotStyle} />
      </div>
      <div css={textStyle}>
        {t('storygame_ai_onboarding_screen_description_character_name')}
      </div>
    </div>
  );
};

export default StoryGameCharacterListError;
